module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cep"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("All this has happened before, and it will all happen again.")])]), _vm._v(" "), _c('p', {
    staticClass: "cepc"
  }, [_vm._v("J.M. Barrie, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Peter Pan")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("Following recuperation, and a $1.5 million payout from Pepsi to prevent a lawsuit,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-01",
      "id": "notes-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Michael began work on the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Victory")]), _vm._v(" tour. Despite being opposed to both the album and the tour in the beginning, Michael enjoyed performing with his brothers again. They played 55 shows over five months and it was a chance for them all, and the audiences, to relive the days of The Jackson 5 and The Jacksons. But as the tour progressed, Michael became increasingly unhappy, being particularly disappointed and frustrated with the staging of ‘Billie Jean’. His brothers were less than enamoured with Michael, too. He had taken to travelling alone and was refusing to stay on the same hotel floor as them. The tour closed in Los Angeles on 9 December 1984. Whilst its promoters, along with Joe Jackson, were discussing a European leg of the tour, Michael had made his mind up that there would be no more performances. In a final nod to his distaste for the tour, and not wanting any legacy from it, Michael donated his entire earnings from it – some $5 million – to charity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before the tour began, Michael had already started to look for a new manager to work alongside John Branca and had decided upon Frank Dileo, whom Michael believed was responsible for a lot of the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thriller")]), _vm._v(" success in the way he had promoted the album. Frank Dileo had begun his career at RCA Records while in his twenties and then became Epic’s Vice-President of Promotion with huge success. He was an enormous character, both in charisma and physical presence, and was just the man to steer Michael forward with John Branca remaining as his attorney.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was Dileo and, more prominently, Branca who oversaw Michael’s purchase of the ATV Music Publishing Company in 1985. The ATV Music Publishing Company held the rights to over 4,000 songs including 251 songs by The Beatles. During a conversation with Paul McCartney in London, Michael had learnt how profitable investments in such catalogues could be and how Paul himself had tried to buy the ATV catalogue previously, but had baulked at the $20 million asking price. Interested enough to pursue this further, Michael first bought the catalogue of Sly Stone to test the water, and in September 1984 he learned from Branca that the ATV catalogue was available. Not entirely certain of what the ATV catalogue consisted of, it was when Jackson discovered that it contained, amongst others, many of The Beatles’ hits, as well as songs by Elvis Presley and Little Richard, that he became adamant he must buy it. From September 1984 to May 1985, Branca worked furiously for Jackson in order to secure the catalogue, but it came at a price – $47.5 million."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-02",
      "id": "notes-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Paul McCartney had also tried to buy the catalogue during this period, and was hoping to convince Yoko Ono, John Lennon’s widow, to provide half of the purchase cost. When she didn’t, the door for Jackson was wide open. Few could have seen how lucrative this investment would turn out to be, and Jackson’s share in the catalogue virtually single-handedly gave him a financial lifeline later in life. It was a lifeline that prevented him from hitting rock bottom earlier, yet perhaps also one that enabled him to avoid confronting his drug addiction.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In 1987 it had been five years since Michael’s last solo album. The years in between had seen the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Victory")]), _vm._v(" album and tour, and also, in 1985, the release of the charity single ‘We Are The World’, which Michael had co-written with Lionel Richie in aid of African famine relief."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-03",
      "id": "notes-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Michael had also worked on the 3D film "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Captain Eo")]), _vm._v(" in 1986, which was to be shown at Disney theme parks."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-04",
      "id": "notes-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Jackson was paid $3 million to take the lead role in the short film which was about his character, Captain Eo, going on a mission to bring the inhabitants of a miserable planet light and beauty through music and so transform their evil leader, played by Angelica Huston."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-05",
      "id": "notes-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Once again, as he did on "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Wiz,")]), _vm._v(" Michael thrived on the medium of film, and took advice about acting from Marlon Brando, who had become a close friend at that time. Michael also performed two new songs in the film: ‘Another Part of Me’ and ‘We Are Here to Change the World’.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘Another Part of Me’ was to appear on Michael’s next solo album, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bad.")]), _vm._v(" Recorded from January to July 1987, the album had to follow in the footsteps of Jackson’s previous solo album, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thriller,")]), _vm._v(" which had become the world’s biggest-selling album of all time. Once again, he recruited Quincy Jones to act as producer"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-06",
      "id": "notes-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" and, between them, they worked to make an album that was as close to perfection as humanly possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael had written 62 potential songs for the album, which had to be whittled down to 30 songs that would be recorded."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-07",
      "id": "notes-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Eventually, the album consisted of ten songs,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-08",
      "id": "notes-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" of which Michael composed eight."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-09",
      "id": "notes-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" When it was released at the end of August 1987, it reached Number 1 in 25 countries, and spent six weeks at Number 1 on the US "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Billboard")]), _vm._v(" 200,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-010",
      "id": "notes-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" selling over 9 million copies in the USA. It also became Jackson’s second-most successful album in the UK, selling almost 4 million copies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first five singles released from the album all reached Number 1 in the USA,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-011",
      "id": "notes-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" a feat that topped even "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thriller.")]), _vm._v(" Jackson had wanted to create an album that would appeal to all races and all tastes in music but, despite the commercial success, and critical reception"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-012",
      "id": "notes-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" to "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bad,")]), _vm._v(" it just didn’t measure up to "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thriller.")]), _vm._v(" How could it? By most standards, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bad")]), _vm._v(" was an astounding success, but Jackson wasn’t satisfied. His ambition had been to sell 100 million copies of the album,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-013",
      "id": "notes-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" yet it had sold "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("only")]), _vm._v(" 35 million copies worldwide and won just one Grammy Award."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-014",
      "id": "notes-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bad")]), _vm._v(" tour that followed saw Jackson walk away with $40 million,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-015",
      "id": "notes-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" and 1988 also saw the release of the film, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Moonwalker,")]), _vm._v(" a film consisting of a number of short films about, and featuring, Jackson. It was during the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bad")]), _vm._v(" tour that Jackson purchased a property for himself on 5225 Figueroa Mountain Road, Los Olivos, California, from the golf course entrepreneur William Bone. The sprawling 2,700-acre ranch was named Sycamore Ranch but Jackson renamed it Neverland Ranch."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-016",
      "id": "notes-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The ranch was vital for Jackson as it gave him the isolation he craved, therefore enabling his addictive nature.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Despite the advice of John Branca, who counselled Jackson that it might not be a good business investment, the singer purchased the property for $17 million."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-017",
      "id": "notes-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" He then proceeded to spend another $55 million adding an amusement park, zoo, and private steam railroad to transport passengers up the drive and around the estate."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-018",
      "id": "notes-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Jackson certainly had the cash, it seemed. In 1988 alone, he earned approximately $125 million.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was Neverland Ranch, however, that was the scene of the scandal in 1993 that saw the turning point in Michael Jackson’s career.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was when Evan Chandler, father of 13-year-old Jordan Chandler, accused Jackson of sexually abusing his son at Neverland, that Jackson suddenly found himself facing a lawsuit. His public image was under intense scrutiny and the scandal brewing threatened to tarnish him forever, destroy his career and rob him of his wealth. In many ways it succeeded and he never truly recovered from it, professionally or personally.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael had first met Jordan Chandler in Los Angeles in May 1992 in rather bizarre circumstances. Jackson’s car had broken down in Beverly Hills and he was standing beside it in frustrated confusion about what to do when an eagle-eyed employee of a car-rental business spotted him and called the owner, David Schwartz. Schwartz was the stepfather of the then 12-year-old Jordan Chandler. He called his wife, June, and told her to bring Jordan to the office where he’d be bringing Michael Jackson. Schwartz had offered Jackson a free rental car if the star would agree to take the boy’s phone number and call him."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-019",
      "id": "notes-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Jackson agreed. He kept his part of the bargain and phoned Jordan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson didn’t limit the communication to just one phone call and continued to speak with Jordan over the phone during the next few weeks. It was during one of these calls that Jackson suggested Jordan visit his apartment in Century City, California. The boy’s mother didn’t let him visit Jackson at that time as he was preparing for his final seventh grade exams at St Matthew’s School in Santa Monica, but, three months later, when Jackson had returned from a major promotional tour, Jordan and his mother and sister, became frequent visitors to Neverland where Jackson showered them with attention and gifts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The previous year, 1991, Jackson had switched record labels, leaving CBS and joining Sony in one of the most lucrative recording contracts in the history of the entertainment industry, valued at $65 million, with experts suggesting it could eventually rise to $1 billion. He had also released his eighth solo album, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dangerous,")]), _vm._v(" following 16 months of production. Quincy Jones had been replaced by Teddy Riley in the producer’s hot seat, making this the first Jackson album not produced by Jones since 1975. Upon release in November 1991, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dangerous")]), _vm._v(" became the fastest-selling Michael Jackson album ever in the USA, eventually selling 7 million copies in America alone."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-020",
      "id": "notes-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" However, only one Number 1 single in the US pop charts, ‘Black or White’, emerged from the album."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-021",
      "id": "notes-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A worldwide tour followed, sponsored once more by Pepsi-Cola for a reported $20 million, and again Jackson donated all profits from the 72 concerts to charity. It was during the break between the two legs of this tour, that the Chandlers frequently visited Neverland at Jackson’s invitation."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-022",
      "id": "notes-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Michael showered them with his generosity, including $10,000 shopping trips to Toys ‘R’ Us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson also invited Jordan, his mother June and his five-year-old half-sister Lily to Las Vegas in March 1993 where he had a private suite at The Mirage Hotel. One night, June and Lily decided to go to bed early, leaving Michael and Jordan alone. That night, the two of them watched "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Exorcist")]), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-023",
      "id": "notes-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" together, which scared Jordan so much that he, allegedly, asked to stay in Michael’s room."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-024",
      "id": "notes-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" When Jordan’s mother ventured into her son’s bedroom the following morning and saw that his bed had been undisturbed, she became concerned. June then saw Jordan leaving Michael’s bedroom and confronted her son, who reassured her nothing improper had happened. She scolded him against ever doing such a thing again."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-025",
      "id": "notes-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next day, after Jordan had told Jackson about his mother’s reaction, Jackson sought out June to discuss the matter with her. He tried to convince her that they had an innocent friendship before breaking down in front of her. The following day, he gave her a $12,000 Cartier bracelet. In April, June took her children to Neverland again for five days and every night from then on, Jordan slept in the same room as Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When word reached Jordan’s estranged father, Evan Chandler, he was less than accepting of the situation. Evan was a wannabe screenwriter who had minor success in Hollywood with the comedy "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Robin Hood: Men in Tights,")]), _vm._v(" but he had failed to capitalise on this and by 1993 had fallen behind with alimony payments and was almost $70,000 in debt. When Evan saw an article in the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("National Enquirer,")]), _vm._v(" in which Jackson was photographed alongside Jordan with the accompanying article alluding to Jordan being part of Jackson’s new, adopted family, Evan decided enough was enough. Even though he was estranged as a father, he still felt threatened that he was being overshadowed as the dominant male figure in his son’s life. He made a point of visiting Jordan at home when Michael was there, and felt uneasy enough about Jackson and the situation to ask outright whether Jackson was having sex with Jordan. Calmly, Jackson responded by saying such accusations were preposterous and giggled. Despite Jackson’s protestation of innocence, Evan was constantly pressuring Jackson to explain the nature of his relationship with Jordan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Evan applied to make changes to the custody agreement that he had with June in relation to Jordan in an attempt to stop Jackson seeing more of the boy by preventing Jordan from being anywhere near Jackson. The associated paperwork from Evan suggested he hadn’t received a straight answer from Jackson after he had confronted the singer about whether he was having sex with Jordan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Despite this application, and the damaging material within it, June and Jordan had planned to accompany Michael for five months on the next leg of his "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dangerous")]), _vm._v(" tour. In mid-1993, Dave Schwartz secretly recorded a conversation he had with Evan during which it emerged that Evan suspected Jackson was having sex with Jordan and that he had hired an attorney to investigate the matter in more detail. When Michael heard about this, he didn’t think there was much to worry about, but June and Dave felt they should be concerned. They discussed the matter with Jackson’s investigator, Anthony Pellicano, and one of Michael’s attorneys, Bert Fields. Immediately they sensed an element of extortion and spoke to Jordan independently and alone, who confirmed that no sexual impropriety had taken place between him and Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An agreement to let Evan have Jordan for a week was agreed between all parties, but, at the last moment, Jackson and June changed plans and whisked Jordan away to Neverland to celebrate his sister’s birthday. Evan wasn’t informed. Travelling with her son and daughter alongside Jackson in his limousine, June was shocked when the singer responded angrily to a phone call from his attorneys telling him to get Jordan back to his father, where he was supposed to be, immediately. Losing their appetite to go to Neverland following Jackson’s outburst, June, her son and daughter, got a cab back to their Los Angeles home. Suddenly suspecting something sinister might actually be going on, June didn’t even contest Evan’s new custody agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By now, Evan was keen to pursue Jackson and when the LAPD suggested they were already investigating a paedophile claim against Jackson, June began to fear the worst, too."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-026",
      "id": "notes-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" When Michael refused to meet her, on the advice of his lawyer, June became suspicious and sided with Evan in not allowing Jackson access to Jordan. Jackson also refused to meet Evan, for fear of providing him with more ammunition.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A few weeks later, on 2 August 1993, Jordan had a painful tooth removed by Evan, who had given up on his screenwriting career and was now working as a respected dentist in Beverly Hills."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-027",
      "id": "notes-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" During the procedure, Evan used Sodium Amytal to dull the pain his son would feel. Sodium Amytal is otherwise known as a ‘truth serum’ and while under its influence, Evan claimed Jordan spoke openly about sexual activity with Jackson, saying that the singer had touched his penis.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Two days later, Evan managed to gain a meeting with Michael Jackson, during which he stated that he believed the singer had acted inappropriately with his son and suggested Jackson undertake a lie detector test. When Jackson, under advice from his lawyer, refused, Evan stormed out of the room. Shortly afterwards, Evan Chandler’s attorneys laid their cards on the table – they demanded $20 million from Jackson to avoid a trial."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-028",
      "id": "notes-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson was about to begin the next leg of the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dangerous")]), _vm._v(" tour (the first leg had finished in Japan on New Year’s Eve 1992), and his team held a counter press conference, after the allegations were made public, accusing Chandler of trying to extort $20 million from the singer. In the days that followed, two other young boys came forward to confirm they had shared a bed with Jackson but that nothing sexual had occurred.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first part of 1993 was a tough year for Jackson with the intensity of the allegations growing and growing, and public opinion turning against him. He was concerned it might have a catastrophic effect on ticket sales for the second leg of his tour, beginning in Bangkok on 24 August 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With all of this stress and strife, Jackson began taking painkillers more regularly and in greater quantities, painkillers such as Valium, Xanax and Ativan. He attributed the use of painkillers to the 1984 accident on the set of the Pepsi commercial and continuing surgery he was having on his scalp, although, it seems the truth was that the drugs were recreational, and that he had been dependent on them for some time. Only now he was increasing the quantities."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-029",
      "id": "notes-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With the child molestation allegations continuing to dominate his world, Michael lost weight, refused to eat, and had to eventually cancel the remainder of the tour after a show in Mexico City"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-030",
      "id": "notes-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" on 11 November 1993, and fly to London with Elizabeth Taylor"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-031",
      "id": "notes-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" where he immediately entered a drug rehabilitation clinic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Meanwhile, back in the USA, having refused to pay the $20 million to the Chandlers, a trial was set for March 1994. Before then, in December 1993, Jackson would have to undergo a humiliating strip search at his ranch,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-032",
      "id": "notes-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" during which detectives would try to establish a connection between Jordan Chandler’s description of Jackson’s private anatomy and his actual physique."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-033",
      "id": "notes-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Around this time, Jackson’s sister, La Toya, also joined in the ongoing media circus, by speaking out against him. While in Tel Aviv on 8 December 1993, she told reporters at a news conference: ‘This has been going on since 1981, and it’s not just one child’, according to wire service reports. Reuters news agency reported she went on to say that she can no longer ‘be a silent collaborator of his crimes against small innocent children. If I remain silent, then that means that I feel the guilt and humiliation that these children are feeling, and I think it’s very wrong.’"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-034",
      "id": "notes-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" She said that she had seen cheques made out for ‘very, very large amounts’ to the parents of these children and hinted that she had proof to support the allegation that her brother was a paedophile, and she would reveal it to anyone prepared to listen, but only if they would pay her half-a-million dollars."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-035",
      "id": "notes-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Newspapers rushed to be the first ones to secure her exclusive story, but it soon became obvious that she had no proof and the newspapers left with their money intact."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-036",
      "id": "notes-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Despite this, and the anger of her family towards her for encroaching on her brother’s tribulations in such a mercenary way, La Toya did appear on a number of documentaries to describe her brother’s life and her relationship with him, and made some decent money in the process. But there was no compelling evidence to back up what she said, no smoking gun that confirmed Michael Jackson as a compulsive child molester.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("While Jordan Chandler was celebrating his fourteenth birthday on 11 January 1994, documents were filed that day in the Los Angeles Superior Court by the prosecution team as part of evidence against Jackson and also requesting access to his financial records. The details of the case were now in the public domain, and whether people were fans of the singer or not, the case was attracting international attention and opinions were being cast about the guilt or innocence of Michael Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Within two weeks, with a trial looming, Jackson settled on an out of court agreement that would see him pay a total of more than $20 million to the Chandlers and their attorney despite a lack of evidence and no victims willing to testify against Jackson."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-037",
      "id": "notes-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("While Jackson himself just wanted to be rid of the case, many around the world saw the fact that he had settled as some confirmation of guilt on his part. As author Lynton Guest wrote,")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_vm._v("Jackson came under intense pressure to settle the case, especially from his management and his record label, Sony, not because they thought he was guilty, but for commercial considerations whatever the outcome of the case might have been. They believed that even if a criminal trial resulted in a not guilty verdict, severe damage would be inflicted on Jackson’s career with massive financial consequences for themselves. It must be said that many of them, particularly at Sony, felt Jackson was guilty. What they failed to realize was that a settlement, while not legally an admission of guilt, is nevertheless regarded as such by large sections of the public and most of the media."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-038",
      "id": "notes-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Michael Jackson always maintained his innocence but the damage had already been done; within weeks Pepsi-Cola cancelled an endorsement with him, the film projects he had been working on all collapsed without exception and Disneyland stopped showing the 3D film, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Captain Eo,")]), _vm._v(" which heavily featured Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Throughout the Chandler case, Jackson was without both Frank Dileo and John Branca. He had fired Dileo around the time he purchased Neverland, primarily on the basis that "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bad")]), _vm._v(" hadn’t done as well as "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thriller")]), _vm._v(" and, despite Dileo’s best efforts, Jackson felt he perhaps could have done a better job."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-039",
      "id": "notes-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Of course, it was a no-win situation. How could anybody top "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thriller?")]), _vm._v(" ‘We did the best we could. We made the best album and the best videos we could. We don’t have anything to be ashamed of,’ Frank Dileo recalled of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bad.")]), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-040",
      "id": "notes-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" The man tasked with the job of delivering the news of his firing to Dileo was John Branca. And it wasn’t long before Branca received a letter from Jackson’s new accountant informing him that his services, too, were no longer required by Jackson."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-041",
      "id": "notes-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Michael had become increasingly insecure with regards to Branca, specifically that he had taken on other clients. One in particular, the British singer Terence Trent D’Arby was perceived by Jackson as competition"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-042",
      "id": "notes-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" and another, The Rolling Stones, were embarking on a huge tour that appeared to Jackson to dwarf any tour he had previously done."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-043",
      "id": "notes-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Despite losing both of these trusted confidantes, Jackson found someone else to lean on during the difficult Chandler period of his life, Lisa Marie Presley. They had met in January 1993 when Presley was pursuing her own singing career having made a rough demo and hoping the input of Jackson, arranged through a mutual friend, might help her hone her skills. Jackson, at that point, wasn’t too interested in helping out, but their friendship developed throughout the year against the backdrop of the Chandler scandal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lisa Marie was married and had two children with the musician Danny Keough, but Jackson had become besotted with her and plied her with gifts and flowers. In February 1994 he invited her to stay with him at The Mirage Hotel in Las Vegas to see The Temptations, an invitation she accepted, and later that month he asked her to Neverland. In April, Lisa Marie separated from her husband and, 20 days after her divorce came through, she married Michael in the Dominican Republic. It was a week before Lisa Marie told her mother, Priscilla Presley, that she had married Jackson, and it took two months for Jackson and his new wife to announce their marriage to the world. Was this marriage one of true love? Or, was it an attempt to boost Jackson’s tarnished image; to prove he was a normal heterosexual man, capable of a fulfilling sexual relationship with a woman who, it was rumoured, had a voracious sexual appetite?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whatever the reason, just over a year later, the marriage was in trouble. Priscilla Presley was convinced that, indeed, Michael had married her daughter to try to repair his public image, and Lisa Marie had been photographed on holiday in Hawaii with her ex-husband and their children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson, meanwhile, was hard at work on his new album, the double-album "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("HIStory,")]), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-044",
      "id": "notes-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" which was released in June 1995. It was the first album to be released following the accusations of his child molestation and it came out on his own label, MJJ Productions. The album reached Number 1 in the USA, selling over 7 million copies, and also topped the charts in the UK, as well as selling over 6 million copies in Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But despite Sony spending over $30 million promoting the album as well as the $50 million advance Jackson had received for it, only one single – ‘You Are Not Alone’ – out of five released from it reached Number 1 on the US "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Billboard")]), _vm._v(" Top 100."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-045",
      "id": "notes-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" The world tour that accompanied the album was the final solo world tour by Jackson and consisted of 85 concerts in 35 countries attended by over 4.5 million fans and generating over $165 million in gross revenue."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-046",
      "id": "notes-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" As the tour progressed, Jackson’s relationship with Presley continued to deteriorate and when Jackson collapsed on 6 December 1995 in New York while rehearsing for a TV special,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-047",
      "id": "notes-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" questions over the state of the marriage began to be asked, particularly when his mother and sister, Janet, managed to visit Michael in hospital before Lisa did and her whereabouts were unknown. More questions were asked when Michael left hospital on 12 December and headed straight to EuroDisney with some cousins but without his wife."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-048",
      "id": "notes-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" In fact, Lisa Marie did visit the hospital but Michael had to be convinced to let her actually visit him, and when she finally saw her husband (in his room decorated with posters of Mickey Mouse and Shirley Temple) a row ensued between the two of them, as she started asking questions about his health and treatment and Michael asked her to leave."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-049",
      "id": "notes-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Lisa Marie filed for divorce from Jackson, citing irreconcilable differences, in January 1996. The divorce settlement ensured her 10 per cent of royalties from the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("HIStory")]), _vm._v(" album, but by that point, another woman, Debbie Rowe, was pregnant with Michael’s child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Debbie Rowe was an assistant to Michael Jackson’s dermatologist, Dr Arnold Klein, and the two of them had struck up a friendship over the many years that Jackson had been visiting Klein. The news of the pregnancy emerged in November 1996, as well as the fact that the baby was conceived at the Los Angeles Fertility Institute"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-050",
      "id": "notes-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" and that Debbie Rowe would be paid $500,000 by Jackson when she gave birth to the baby."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-051",
      "id": "notes-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Ten days after the story of the pregnancy was headline news in newspapers worldwide, Jackson married Debbie Rowe. His best man was an 8-year-old boy named Anthony."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-052",
      "id": "notes-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From the start of their marriage, Jackson and Rowe lived in separate houses, and the baby was looked after by two nurses and two nannies. Michael and Debbie would divorce amicably in 1999,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-053",
      "id": "notes-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" but their marriage resulted in two children, Prince, born in 1997, and Paris, born a year later."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-054",
      "id": "notes-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In 1996, Michael, determined to make it in films, made the little-seen short film, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Michael Jackson’s Ghosts,")]), _vm._v(" which was directed by Stan Winston and co-written with Michael by horror-novelist Stephen King. With Jackson playing five major roles himself, the film was screened out of competition at the 1997 Cannes Film Festival, after which it disappeared without a trace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Returning to what he did best, Michael released a remix of his "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("HIStory")]), _vm._v(" album in 1997, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Blood on the Dancefloor: HIStory in the Mix.")]), _vm._v(" On the album, Jackson remixed eight tracks from his previous studio album and performed five new songs. The album sold 6 million copies worldwide, making it the biggest-selling remix album ever released. One of the new songs on the album was a track titled ‘Morphine’, one of Jackson’s darkest songs, full of sadness and anger and a repetitive chorus containing the word, Demerol, which is a narcotic analgesic with effects similar to Morphine. It acts on the central nervous system by tricking the brain into replacing the feeling of pain with a ‘high’. Demerol was a drug that Jackson would have become familiar with during his regular visits to his dermatologist, Dr Klein in Beverly Hills. It would have been used as a painkiller during the uncomfortable cosmetic procedures that Jackson was routinely undergoing with Dr Klein and, later, it was rumoured Jackson only underwent cosmetic procedures as they allowed him access to Demerol.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("While the album reached Number 1 in the UK, it failed to ignite record buyers’ imaginations, only peaking at Number 24 in the US "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Billboard")]), _vm._v(" 200 and eventually selling barely 1 million copies in the States. This lack of success, especially in the USA, coupled with the recent controversies, meant that, for Sony, Michael was no longer the priority he thought he was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Despite this flop, Sony still ended up with costs of anywhere between $30 million and $40 million for Jackson’s next album, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Invincible,")]), _vm._v(" as well as spending up to $25 million promoting it"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v(".")]), _vm._v(" Michael had started recording songs that were included on this album as far back as 1997 but his painstaking perfectionism meant the album wasn’t ready for release until October 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He hadn’t released a studio album for six years, hadn’t toured for almost as long and hadn’t secured any commercial endorsements, owing to the whiff of scandal still emanating from the Jordan Chandler affair. All this meant that his income had significantly decreased from its peak less than a decade earlier when Jackson was routinely earning $100 million per year. His annual overheads now were nearly $20 million but his income was considerably less, around $10 million to $12 million, and he was relying on taking out loans against his half of the Sony/ATV catalogue to support his lavish lifestyle. Friends were becoming increasingly concerned about his dependence on prescription painkillers, and Jackson himself was about to discover that his contract with Sony wasn’t what he expected it to be.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before the services of his attorney, John Branca, had been dispensed with unceremoniously in 1990, Branca had overseen Jackson’s contract with CBS. The Sony contract had been rewritten, however, without Jackson’s knowledge by one of the people that had replaced Branca. Jackson had been under the impression he could get out of the Sony contract in 2000 and that the licence to the masters of albums such as "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thriller")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bad")]), _vm._v(" would revert back to him. With these then in his control he could exploit them fully and reap the financial rewards.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What emerged upon closer inspection was that clauses existed that demanded Michael release a new CD for Sony every two years, as well as a Christmas CD and two soundtracks. To make matters worse for Jackson, the original three-album deal had been amended to five albums. There were also massive financial penalties for not completing albums: up to $20 million for each unfinished album. Whatever course of action he took, it appeared Jackson would owe Sony hundreds of millions of dollars even if he managed to get himself out of the contract. But owing to a formula called the ‘Dunkirk Clause’,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-055",
      "id": "notes-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" if Jackson left Sony, he would inherit the mechanical copyright ownership of his recordings and if Sony attempted themselves to get rid of Jackson, a messy legal case would ensue which would cost them a fortune. As Lynton Guest states in his book, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Trials of Michael Jackson,")]), _vm._v(" ‘… those at Sony had to find a way to get rid of Jackson but keep hold of the rights to his recordings.’ By keeping control of Jackson’s back catalogue, Sony could also keep themselves close to his share of the Sony/ATV catalogue in the hope of eventually gaining full control of that too. They just had to find a convenient way of getting rid of Jackson, whilst making it appear as though he was to blame."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-056",
      "id": "notes-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the end, Jackson found out that the attorney who represented him during the formulation of the deal also represented Sony. It was a classic conflict of interest and enabled Jackson to navigate his way out of the Sony contract on the basis he delivered "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Invincible")]), _vm._v(" and a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Greatest Hits")]), _vm._v(" package. But even this backfired, as Sony managed to keep the mechanical rights to Jackson’s back catalogue when he failed to deliver the material he was originally contracted for."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-057",
      "id": "notes-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was little motivation for Jackson to put all his effort into "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Invincible")]), _vm._v(" in these circumstances, but he finally delivered the album in August 2001 and it was released on 30 October that year. It entered the album charts at Number 1, but only stayed there for one week. Four singles were released from the album, all with just moderate success."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-058",
      "id": "notes-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" The album ended up selling around 10 million copies worldwide, but for an artist of Jackson’s stature and reputation, at least in his mind, this was considered a failure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Shortly after the release of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Invincible,")]), _vm._v(" Jackson performed two shows at Madison Square Garden. His friend, David Gest, produced the shows which celebrated Michael’s 30 years as a solo entertainer and contained performances by The Jacksons, along with guest appearances by artists such as Britney Spears, Slash and Kenny Rogers, and, of course, solo performances by Michael himself."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-059",
      "id": "notes-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Michael was reportedly paid $15 million for the two concerts."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-060",
      "id": "notes-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After appearing disoriented during the first concert, David Gest claimed in the documentary, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Michael Jackson: The Life of an Icon,")]), _vm._v(" that Jackson was high on drugs during the shows. Jackson retorted by saying that he simply did not rehearse for the first show.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In 2002, Sony unsurprisingly chose not to renew Jackson’s recording contract, which was hardly a tough decision for them to make given the cost of the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Invincible")]), _vm._v(" album, the lack of a tour to promote it, declining sales generally and the fact that Jackson had suggested Sony’s then-chairman, Tommy Mottola, was a racist."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-061",
      "id": "notes-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" All of a sudden, Jackson had no record label, although at that point his desire to actually make new music was questionable anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson’s unpredictability in 2002 continued when he was photographed dangling his nine-month-old son, Blanket, over the balcony of a hotel in Berlin, then following that event by taking his other two children, Prince and Paris, to visit Berlin Zoo, hiding their faces under hoods and behind masks. But this bizarre behaviour was nothing compared to what was about to happen in February 2003 when a documentary was aired on British television.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Living With Michael Jackson")]), _vm._v(" trailed British journalist Martin Bashir from ITV as he spent eight months following Jackson in every aspect of his daily life, including an outrageous shopping spree in a Las Vegas mall where Jackson spent over $1 million in less than an hour on tasteless artefacts. At the heart of the documentary, however, was a relentless investigation of Jackson’s constantly changing appearance and his relationships with young boys, including an interview with a 13-year-old cancer survivor named Gavin Arvizo who stated that Jackson had said to him during one of his many visits to Neverland that ‘… the most loving thing to do is to share your bed with someone, you know?’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Over 50 million people worldwide watched the documentary. Despite Jackson’s best efforts at damage limitation – in a video rebuttal he accused Bashir of presenting a distorted picture of the singer’s behaviour and conduct – his reputation was in tatters once more."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-062",
      "id": "notes-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson’s manager at the time, Dieter Wiesner, told "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Sun")]), _vm._v(" that the documentary ‘… broke him. It killed him. He took a long time to die, but it started that night. Previously the drugs were a crutch, but after that they became a necessity.’"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-063",
      "id": "notes-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In November 2003, while Jackson was in Las Vegas, Neverland was raided by the police once more as part of an ongoing criminal investigation, and, at a press conference the following day, it was announced that an arrest warrant had been issued for the charge of Jackson molesting a child."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-064",
      "id": "notes-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" If found guilty, Jackson would face 45 years in jail. Jackson went on the offensive and employed a top legal team for the trial, scheduled for February 2005. They discovered that the Arvizo family had a track record of making abuse allegations and, during the trial, when it was alleged by one of Michael Jackson’s employees that he had seen the singer fondle child-actor Macaulay Culkin, Jackson’s legal team not only discovered the employee had been approached by tabloids to sell the story with a scale of payment increasing according to salaciousness, but also called Culkin to the witness stand where he categorically denied any allegations of abuse against him by Jackson. They also discovered that the dates of the allegations made by Arvizo against Jackson were actually made "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("after")]), _vm._v(" the Bashir documentary was screened, therefore "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("after")]), _vm._v(" Arvizo had been recorded on camera saying he and Jackson shared a bed. Put simply, the Arvizo family smelled an opportunity to make money."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-065",
      "id": "notes-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The trial lasted for four months, but Jackson was eventually acquitted of all 14 counts in June 2005."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-066",
      "id": "notes-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" With his career now firmly derailed, the singer sought to escape the USA as quickly as possible, maybe forever. His exile began in Bahrain, on 19 June 2005, where Jackson had connections within the tiny Persian Gulf state"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-067",
      "id": "notes-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" – he was close friends with Sheikh Abdullah bin Hamad bin Isa Al Khalifa, the second son of the King of Bahrain. Abdullah had loaned Jackson £1.4 million"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-068",
      "id": "notes-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" to help pay legal fees after the 2005 child molestation trial."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-069",
      "id": "notes-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sheikh Abdullah considered himself a songwriter and had met Jackson in 2004 when they agreed to work together on some songs to raise money for the victims of the Asian tsunami and Hurricane Katrina. Now, in Bahrain, Sheikh Abdullah spent $300,000 to provide Jackson with a ‘motivational guru’ and built him a recording studio so they could work together."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-070",
      "id": "notes-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" He had also provided a stately palace and a number of luxury cars for Jackson, his three children and their nanny, Grace Rwaramba."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-071",
      "id": "notes-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" The sheikh also flew out Jackson’s hairdresser at his own expense, gave the singer $35,000 to pay utility bills at Neverland,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-072",
      "id": "notes-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" and even paid $350,000 for a European jaunt for Jackson and his entourage."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-073",
      "id": "notes-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whilst in Bahrain, Jackson found himself on the brink of having to default on his $270 million Bank of America loan. The Fortress Investment Group had purchased this loan from the Bank of America in 2003 after Jackson had already missed some payments. With lifestyle expenses far exceeding his income – he was spending about $2 million per month – Jackson’s debts were approaching $415 million. He managed to survive by constantly borrowing against his stake in the Sony/ATV catalogue."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-074",
      "id": "notes-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On 20 December 2005, Fortress threatened to call in its loan. In order to keep Jackson financially afloat, Sony agreed an extension with Fortress and brought in Citigroup and other potential lenders to arrange a new financing agreement. Citigroup offered Jackson a new loan at an interest rate of 6 per cent when Jackson agreed to give Sony the right to buy half of his 50 per cent stake in The Beatles’ catalogue for $250 million – a form of security for Citigroup if Jackson defaulted again. Fortress then offered the same terms, incredibly, and within four months a deal was in place with Citigroup providing a $25 million re-mortgage on Neverland, most of which Jackson used to buy back a 5 per cent stake in the ATV catalogue held by one of his early advisors, John Branca."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-075",
      "id": "notes-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In April 2006, still in Bahrain, Jackson signed a deal with Sheikh Abdullah for a $7 million advance payment, which meant he would write and record new material for an album to be released by Sheikh Abdullah’s record company, Two Seas Records. But Jackson reneged on the deal, and in 2006 left Bahrain as quickly as he arrived, leaving Sheikh Abdullah to sue Jackson for the $7 million."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-076",
      "id": "notes-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson’s next stop was County Westmeath in rural Ireland. He arrived with his family in the summer of 2006 and stayed for the rest of the year in Grouse Lodge, a secluded Georgian estate with its own recording studio that he rented for $150,000 per month. Here, Jackson began working on new music projects with artists such as will.i.am, who flew in from the USA for the sessions. While in Ireland, Jackson started to look at potential houses to buy, but instead of ending up in Ireland, by 2007 Jackson found himself back in the USA, the country he had vowed never to return to following his acquittal at the 2005 trial.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson had secretly flown back to Las Vegas on 22 December 2006. He could no longer escape the financial turmoil he was in by running away. He had severed all ties with his family, except his mother, and the only way he could make some money was to work."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-077",
      "id": "notes-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" And where better for an entertainer to secure a lucrative headline slot than in the hotels that lined the Strip in Las Vegas?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson’s Las Vegas residency began in the rented seven-bedroom mansion at 2785 South Monte Cristo Way. Despite having major financial problems, Jackson managed to negotiate a fee of $1 million to rent the property for six months. Soon, word got out that Jackson was living there, and paparazzi were scaling trees to try and get any photo of him and his children from over the 8 ft high security walls."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-078",
      "id": "notes-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The paparazzi were unsuccessful in getting photos of Jackson or the children as they were hidden out of sight. One person who did get to see the children in Las Vegas was a local doctor. A doctor who had treated the father of one of Jackson’s security guards, he was called out when a bout of influenza struck the Jackson household. His name was Dr Conrad Murray, and he began to visit every six weeks or so to check up on the kids.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Speculation about what Jackson was doing back on American soil was rife. There were all sorts of rumours – he was going to announce a series of 250 concerts at a Las Vegas casino, he would undertake a run of 50 shows at a famous Vegas hotel, there were even rumours that a massive Michael Jackson robot was about to be unleashed in the desert. Another rumour going around was that Jackson was flat-out broke. Those around him simply couldn’t believe it. Even his security guards, who would only get intermittent paychecks, refused to believe the King of Pop was on his hands and knees financially.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The reality of the situation was that he could no longer afford the rent in Las Vegas and had so little cash handy that the nanny, Grace Rwaramba, had to fund balloons herself for Paris’s tenth birthday party."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-079",
      "id": "notes-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" Any prospect of Jackson performing in Las Vegas seemed to have disappeared when two of the main players in trying to set up concerts for Jackson, promoter, Jack Wishna, and property developer, Steve Wynn, released a statement to the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Las Vegas Review Journal")]), _vm._v(" saying that ‘Jackson has given up on trying to relaunch his musical career in Las Vegas and is heading back to Europe.’"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-080",
      "id": "notes-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But Jackson wasn’t returning to Europe. At least, not yet. While his advisors were trying to work out the singer’s finances, Jackson took himself off to New York for the summer of 2007 to stay with the family of Frank Cascio, a record producer. It was while in New York that Sheikh Abdullah caught up with him from Bahrain and began legal proceedings to recoup the $7 million he had advanced Jackson for the unproduced record."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-081",
      "id": "notes-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" At roughly the same time, the Fortress Investment Group filed a Notice of Default & Election to Sell with the State of California, which meant foreclosure on Neverland. As it turned out, Jackson owed $23 million on his mortgage on the property and he was given 90 days to settle the account. If he failed to do so, then Neverland would be up for auction. But, behind the scenes, events were unfolding that would offer Jackson another lifeline.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the spring of 2007, Jackson had met with Randy Phillips, the CEO of AEG Live, an American worldwide sporting and music entertainment producer and promoter. AEG operated the O2 Arena, a 20,000-seat venue on the banks of the Thames in London. Randy Phillips and AEG were on the lookout for a major star to appear at the venue and, despite all the trials and tribulations that had happened to Jackson in the last decade, the thought was that he could still be the key attraction they were looking for. However, at this initial meeting, Jackson seemed distinctly disinterested in the proposal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He seemed more interested in buying a property in Las Vegas that had caught his attention, a $55 million estate in the Durango neighbourhood owned by the Sultan of Brunei. He even persuaded his two favoured security guards to help him break into it one day so that he could inspect the property and imagine his plans for a future life there. These security guards were amongst the many of Jackson’s retinue who were either owed money for previous debts or not being paid for their current work, and they could only wonder how Jackson could possibly think about affording this property."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-082",
      "id": "notes-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the meantime, he was staying at The Palms Casino Resort in Las Vegas, courtesy of its owner, George Maloof, who let Jackson and his family stay in the $20,000-a-night Hugh Hefner Suite for free."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-083",
      "id": "notes-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" While here, he was working in The Palms’ studio mixing and recording new material for the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thriller 25")]), _vm._v(" album, a 25th anniversary edition reissue of his classic 1982 album."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-084",
      "id": "notes-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" However, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thriller 25")]), _vm._v(" was not going to improve Jackson’s finances as Sony informed him they would be keeping all royalties from the album to cover Jackson’s half of the administration costs from the Sony/ATV catalogue, which the singer had, once again, fallen behind on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But this was just a drop in the ocean. A forensic examination of Jackson’s financial woes showed that his debts now totalled $331 million.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With Jackson unable to stay at The Palms gratis forever, it was crucial that a new home was found for him and one of Jackson’s team, Michael Amir Williams, found the singer a new place to live, the Haciendo Palomino house. Only a few months previously, Michael Amir Williams was hired by Jackson to oversee the archiving of his DVD catalogue. Now, much to the amazement of some of the more established members of Jackson’s entourage, Amir Williams, or Brother Michael as he was known within the Nation of Islam, was assuming control of Jackson’s life and acting as though he was his manager. His choice of Haciendo Palomino as Jackson’s next residence was an odd one; it wasn’t in a great neighbourhood in Las Vegas, it was situated right on a busy street, and it was right across the street from an elementary school.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was at this house that Michael Jackson waited for the arrival of Tom Barrack in the fall of 2007. Tom Barrack was the founder and CEO of Colony Capital, a private international investment firm reported to manage around $35 billion worth of investments. Of Lebanese descent, Barrack is listed by "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Forbes")]), _vm._v(" as being the 833rd richest person in the world and was, also, a fan of Michael Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson’s business advisor at the time, Dr Tohme Tohme,"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-085",
      "id": "notes-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" was a character who had decided to devote himself to reviving Jackson’s flagging career. Dr Tohme Tohme was somewhat of a mystery man, a phrase he dislikes, ‘I hate the words “mystery man”’ he said in an interview with The Associated Press in July 2009, ‘I’m a private man. A lot of people like the media and I don’t. I respect the privacy of other people but lately nobody respects mine.’"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-086",
      "id": "notes-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" What is known is that, like Tom Barrack, he’s of Lebanese descent, is a US citizen raised in Los Angeles and a self-made man in the world of finance. Jermaine Jackson had contacted Tohme Tohme a year earlier to help rescue Neverland from falling into foreclosure. He travelled to Las Vegas to meet with Michael and claimed that the two of them instantly bonded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tohme Tohme had heard that Tom Barrack was visiting Las Vegas and had called him to suggest he meet with Jackson, who had a very serious business proposal."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-087",
      "id": "notes-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Barrack agreed to meet the singer to hear what he had to say and arrived at Hacienda Palomino accompanied by Tohme Tohme. Sitting down, Barrack noticed two sets of financial documents on the coffee table in front of him – one was for Neverland, the other was for the Sony/ATV catalogue. Jackson explained that Neverland was going to foreclose imminently and laid out his financial situation with a sharp and lucid mind. Immediately, without looking at the documents, it was obvious to Barrack that Jackson was facing financial ruin."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-088",
      "id": "notes-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Barrack left with the documents, promising to go through everything. What he discovered was the true depth of the financial turmoil Jackson was in. Realistically, Jackson hadn’t worked in over a decade, he hadn’t toured since 1997 and what income he did have was based predominantly on his Mijac portfolio"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-089",
      "id": "notes-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" and the Sony/ATV catalogue. However, this had been refinanced three or four times. His image and likeness earnings had shrunk to just $100,000 per year and, overall, Barrack discovered there was $12 million more going out annually than was coming in"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-090",
      "id": "notes-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" and his total debt was now approaching $500 million, with little left to re-mortgage. Yet, seemingly oblivious to his predicament, Jackson kept on spending and spending.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Aware that Jackson was not only about to lose Neverland, but also his entire catalogue, Barrack cut the singer a deal; he would personally write a cheque for $22.5 million to save Neverland and refurbish the ranch with a view to possibly selling it later at a substantial profit."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-091",
      "id": "notes-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Despite saving Neverland, Barrack realised he had only scratched the surface of Jackson’s financial problems. The singer had ideas such as getting back into films, but Barrack realised the most profitable short-term solution for Jackson to raise substantial sums was a comeback tour."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-092",
      "id": "notes-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" This was something Tohme Tohme had already thought of.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Barrack was frank with Jackson; he told him that it was a straight choice between either a comeback tour or filing for bankruptcy. Tohme Tohme had tried a different approach: using Jackson’s children, and the fact that they had never seen him perform as emotional leverage, as well as tempting Jackson with the thought that the money he could make from such a tour might enable him to buy the Sultan of Brunei’s house in Durango which he so desperately wanted. Seeing the potential, Jackson initially accepted the idea that he’d have to go back on the road. Tom Barrack, as part of the deal, therefore assumed Jackson’s debt on Neverland, and called fellow billionaire Philip Anschutz, the owner of AEG Live, to begin setting up the comeback tour."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-093",
      "id": "notes-93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The thought was that if Jackson’s stature as a performer could be reinvigorated, the value of Neverland would rise, meaning a greater profit if and when sold, and that Jackson could become a resident performer in one of the Las Vegas hotels after the comeback tour.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An intricate cobweb of phone calls and discussions followed, ending with Philip Anschutz encouraging Randy Phillips to meet with Tohme Tohme to investigate what would be needed to secure Jackson performing a series of concerts at the O2 in London.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Unaware that Phillips had already met Jackson to discuss such an event earlier, Tohme Tohme met with Phillips at the Hotel Bel Air to talk about a potential tour. Shortly afterwards, another meeting was held at the MGM Grand in Las Vegas. This time Michael Jackson was present, his youngest son, Blanket, by his side. Also there was Philip Anschutz, Randy Phillips and AEG’s co-CEO, Paul Gongaware. Jackson was dressed in a sober black suit and appeared fit and well, and everybody around the table wanted to hear one thing from Jackson: that the King of Pop was ready to make his comeback. As Jackson sipped bottled water, those facing him across the table were cautiously weighing up the situation. They knew Jackson needed the cash, and AEG Live were keen to land the showbiz scoop of the decade for their O2 Arena in London. Philip Anschutz, a devout Christian, was slightly concerned that hiring Jackson, with the singer’s reputation of child molestation, would not only go against his own principles but would harm his company’s reputation, and needed reassurance. Randy Phillips, who had been wooing Jackson for three years, explained to the singer why he felt London was the perfect venue for the singer’s comeback and, in turn, Jackson explained his own ambition to branch out into films. It just so happened that Philip Anschutz owned the largest cinema chain in the USA, so it seemed the fit was right. Together they discussed their wishes for a new live show and when the meeting ended, Michael Jackson had shaken hands on a series of 10 live comeback concerts at the O2 in London in 2009."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes2#notes-094",
      "id": "notes-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everything was now aligned to drive Jackson to his tragic end.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba559e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 78
// module chunks = 0